import { CONFIG } from "../config"

export class Modal {
  private ref: HTMLDivElement
  private iframeSrc: string

  constructor({ iframeSrc }: { iframeSrc: string }) {
    this.iframeSrc = iframeSrc
    this.ref = this.render()
    this.attachEventListeners()
  }

  private render(): HTMLDivElement {
    const modal = document.createElement("div")
    modal.className = CONFIG.MODAL_CLASS
    modal.innerHTML = `
            <div class="tfg-modal-overlay">
                <div class="tfg-modal-content">
                    <div role="button" class="tfg-modal-close">&times;</div>
                    <iframe src="${this.iframeSrc}" frameborder="0"></iframe>
                </div>
            </div>
        `
    return modal
  }

  private attachEventListeners(): void {
    const closeButton = this.ref.querySelector(".tfg-modal-close")
    const overlay = this.ref.querySelector(".tfg-modal-overlay")

    closeButton?.addEventListener("click", () => this.close())
    overlay?.addEventListener("click", (e: Event) => {
      if (e.target === overlay) this.close()
    })
  }

  open(): void {
    document.body.appendChild(this.ref)
    document.body.style.overflow = "hidden"
  }

  close(): void {
    this.ref.remove()
    document.body.style.overflow = ""
  }
}
